import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Fragment, type ReactNode } from 'react'
import { IconButton } from '../IconButton'

interface DrawerProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: ReactNode
  maxWidth?: string
  closeLabel?: string
}

export function Drawer({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'max-w-72',
  closeLabel = 'Close panel',
}: DrawerProps) {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/40 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel
                  className={`pointer-events-auto w-screen ${maxWidth}`}
                >
                  <div className="flex h-full flex-col overflow-y-auto bg-surface-card dark:bg-dark-card border-l-[2.5px] border-ink dark:border-dark-border shadow-[-4px_0_0_#111111] dark:shadow-[-4px_0_0_#000000] transition-colors">
                    <div className="px-6 py-5 border-b-[2px] border-ink dark:border-dark-border">
                      <div className="flex items-center justify-between">
                        <Dialog.Title className="font-extrabold text-xs tracking-widest uppercase text-ink dark:text-dark-ink transition-colors">
                          {title}
                        </Dialog.Title>
                        <IconButton label={closeLabel} onClick={onClose}>
                          <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                        </IconButton>
                      </div>
                    </div>
                    <div className="relative flex-1 px-6 py-6">{children}</div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
